import {Injectable} from '@angular/core';
import {BaseEndpointService} from './base-endpoint-service';
import {Backend, SingleResponse} from '@generated-backend-types';
import Inquiry = Backend.App.Resources.Dashboard.Inquiry.Inquiry;
import InquiryData = Backend.App.Data.Dashboard.Inquiry.InquiryData;
import {ListItem} from '../../entities/list-item.entity';
import AnswerInquiryData = Backend.App.Data.Dashboard.Inquiry.AnswerInquiryData;

@Injectable({providedIn: 'root'})
export class InquiryService extends BaseEndpointService<Inquiry, InquiryData> {
  protected override endpoint = '/inquiries';

  public override modelToMultiSelectItem(m: Inquiry): ListItem & { model: Inquiry; } {
    return {
      id: m.id,
      text: m.question ?? '',
      isDisabled: false,
      model: m,
    }
  }

  public withdraw(inquiryId: string) {
    return this.http.post<SingleResponse<Inquiry>>(this.endpoint + '/' + inquiryId + '/withdraw', {});
  }

  public answer(inquiryId: string, data: AnswerInquiryData) {
    return this.http.post<SingleResponse<Inquiry>>(this.endpoint + '/' + inquiryId + '/answer', data);
  }
}
